import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import './DailyLockedStatsPreview.css';

const LOCKED_SUMMARY_STATS = Object.freeze([
  { key: 'streak', label: 'Streak', value: 9 },
  { key: 'maxStreak', label: 'Max Streak', value: 21 },
  { key: 'played', label: 'Played', value: 64 },
  { key: 'winPercent', label: 'Win %', value: 88 },
]);

const FAKE_GUESS_COUNTS = Object.freeze([22, 17, 12, 8, 5, 3, 2, 1]);

const buildFakeDistribution = (guessBucketNumbers) =>
  guessBucketNumbers.map((guessNumber, index) => ({
    guessNumber,
    count: FAKE_GUESS_COUNTS[index] ?? 1,
  }));

const DailyLockedStatsPreview = ({ guessBucketNumbers = [] }) => {
  const safeGuessBuckets = useMemo(
    () =>
      (Array.isArray(guessBucketNumbers) ? guessBucketNumbers : []).filter((guessNumber) =>
        Number.isFinite(Number(guessNumber))
      ),
    [guessBucketNumbers]
  );
  const fakeDistribution = useMemo(
    () => buildFakeDistribution(safeGuessBuckets),
    [safeGuessBuckets]
  );
  const maxCount = useMemo(
    () => Math.max(1, ...fakeDistribution.map(({ count }) => count)),
    [fakeDistribution]
  );

  return (
    <div className="stats-container daily-locked-stats" aria-label="Locked daily stats preview">
      <div className="daily-locked-stats__outline">
        <div className="daily-locked-stats__header">
          <Link to="/auth" className="daily-locked-stats__cta">
            <span className="daily-locked-stats__cta-title">Sign in to keep streak</span>
            <span className="daily-locked-stats__cta-subtitle">Unlock full stats + leaderboard</span>
            <span className="daily-locked-stats__cta-bonus">+ PLAY UNLIMITED</span>
          </Link>
        </div>

        <div className="daily-locked-stats__disabled-content" aria-hidden="true">
          <div className="stats-summary daily-locked-stats__summary">
            {LOCKED_SUMMARY_STATS.map((stat) => (
              <div key={stat.key} className="stat-box">
                <span className="stat-number">{stat.value}</span>
                <span className="stat-label">{stat.label}</span>
              </div>
            ))}
          </div>

          <div className="guess-distribution daily-locked-stats__distribution">
            <h3>Guess Distribution</h3>
            {fakeDistribution.map(({ guessNumber, count }) => {
              const percentage = (count / maxCount) * 90;
              return (
                <div key={guessNumber} className="guess-row">
                  <div className="guess-label">{guessNumber}</div>
                  <div className="guess-bar-container">
                    <div className="guess-bar" style={{ width: `${Math.min(90, percentage)}%` }}>
                      {count}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

        <p className="daily-locked-stats__note">Compete with others on the leaderboard.</p>
      </div>
    </div>
  );
};

export default DailyLockedStatsPreview;
